function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.66 5.333c0-.48-.247-.9-.627-1.133L8 .667 1.966 4.2c-.38.233-.633.653-.633 1.133V12c0 .733.6 1.333 1.333 1.333h10.667c.733 0 1.333-.6 1.333-1.333l-.006-6.667zM8 8.667l-5.507-3.44L8 2l5.506 3.227L8 8.667z",
  fill: "#828282"
})));